import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { z } from 'zod';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { SurveySubmissionsPage } from '@/features/surveys/pages/SurveySubmissionsPage';

export const surveySubmissionsSearchSchema = z.object({
  divisionId: z.coerce.number().int().positive().optional(),
  districtId: z.coerce.number().int().positive().optional(),
  thanaId: z.coerce.number().int().positive().optional(),
  departmentId: z.coerce.number().int().positive().optional(),
  userName: z.string().optional(),
  userHrId: z.string().optional(),
  contactNumber: z.string().optional(),
});

export type SurveySubmissionsSearch = z.infer<typeof surveySubmissionsSearchSchema>;

export const Route = createFileRoute('/_auth/feedback/surveys/$surveyId/submissions')({
  parseParams: ({ surveyId }) => {
    const parsedId = Number(surveyId);
    if (!Number.isInteger(parsedId) || parsedId <= 0) throw notFound();
    return { surveyId: parsedId };
  },
  validateSearch: surveySubmissionsSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Survey Submissions">
      <Suspense fallback={<PageLoader />}>
        <SurveySubmissionsPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
